import '@babel/runtime/helpers/extends';
import 'react';
import '@emotion/react';
import SvgStressGlyphSecondary from './svgs/StressGlyphSecondary.js';
import { useIcon } from '../../shared-components/icon/index.js';

var stressGlyph = (props => useIcon(null, SvgStressGlyphSecondary, props));

export { stressGlyph as default };
